import './bootstrap';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { ThemeManager } from './theme-manager';
ThemeManager.initialize();

dayjs.extend(relativeTime);
window.dayjs = dayjs;

// Export to window for usage in components
window.ThemeManager = ThemeManager;

import Swal from 'sweetalert2';
import './components/tab-group.js';
import './components/chat-bubbles.js';
import './toast-notifications';

import('sortablejs').then(Sortable => {
  window.Sortable = Sortable.default;
});

window.Swal = Swal.mixin({
  customClass: {
    popup: 'bg-neutral text-neutral-content rounded-xl shadow-lg',
    confirmButton: 'btn btn-primary',
    cancelButton: 'btn btn-error'
  },
  buttonsStyling: true
});

window.Toast = Swal.mixin({
  toast: true,
  position: 'bottom-right',
  showConfirmButton: false,
  timer: 5000,
  timerProgressBar: true,
  customClass: {
    popup: 'toast-background rounded-xl shadow-lg',
  }
});

let cancelToken;

window.handleSearchInput = function (event) {
  const query = event.target.value;
  const isMobileSearch = event.target.id === 'search-box-mobile';

  // Toggle clear button visibility and transition
  const clearButton = event.target.parentElement.querySelector('.search-clear');
  if (query.length > 0) {
    setTimeout(() => {
      clearButton.classList.remove('opacity-0', 'scale-90');
      clearButton.classList.add('opacity-100', 'scale-100', 'cursor-pointer');
    }, 10);
  } else {
    clearButton.classList.add('opacity-0', 'scale-90');
    clearButton.classList.remove('opacity-100', 'scale-100', 'cursor-pointer');
  }

  // Select appropriate containers based on search source
  const searchResults = document.getElementById(isMobileSearch ? 'search-results-mobile' : 'search-results');
  const searchResultsContent = document.getElementById(isMobileSearch ? 'search-results-content-mobile' : 'search-results-content');
  const searchLoading = document.getElementById(isMobileSearch ? 'search-loading-mobile' : 'search-loading');

  if (query.length < 3) {
    searchResults.classList.add('hidden');
    return;
  }

  // Position the mobile search results appropriately
  if (isMobileSearch) {
    searchResults.classList.add('fixed', 'left-0', 'right-0');
  }

  searchResults.classList.remove('hidden');
  searchLoading.classList.remove('hidden');
  searchResultsContent.innerHTML = ''; // Clear previous results

  // Cancel the previous request if it exists
  if (cancelToken) {
    cancelToken.cancel('Operation canceled due to new request.');
  }

  // Create a new cancel token
  cancelToken = axios.CancelToken.source();

  axios.get('/search', {
    params: { query },
    cancelToken: cancelToken.token
  })
    .then(response => {
      searchLoading.classList.add('hidden');
      const { players, locations, items } = response.data;

      if (players.length === 0 && locations.length === 0 && items.length === 0) {
        searchResultsContent.innerHTML = '<div class="p-2 text-center bg-base-100">No results found</div>';
        return;
      }

      if (players.length > 0) {
        searchResultsContent.innerHTML += '<div class="p-2 font-bold">Players</div>';
        players.forEach(player => {
          searchResultsContent.innerHTML += `
                    <a class="justify-start btn btn-sm btn-ghost btn-block" href="/player/${player.id}" wire:navigate="">
                        <div class="flex gap-2">
                            ${player.avatar_url ? `
                                <div class="avatar">
                                    <div class="size-5 rounded">
                                        <img src="${player.avatar_url}" alt="${player.name}'s profile image">
                                    </div>
                                </div>
                            ` : ''}
                            <span>${player.name}</span>
                        </div>
                    </a>`;
        });
      }

      if (locations.length > 0) {
        searchResultsContent.innerHTML += '<div class="p-2 font-bold">Locations</div>';
        locations.forEach(location => {
          searchResultsContent.innerHTML += `<div class="p-2">${location.name}</div>`;
        });
      }

      if (items.length > 0) {
        searchResultsContent.innerHTML += '<div class="p-2 font-bold">Items</div>';
        items.forEach(item => {
          searchResultsContent.innerHTML += `<div class="p-2">${item.name}</div>`;
        });
      }

    })
    .catch(error => {
      if (axios.isCancel(error)) {
        console.log('Request canceled:', error.message);
      } else {
        searchLoading.classList.add('hidden');
        searchResultsContent.innerHTML = '<div class="p-2 text-center text-error">Error fetching results</div>';
        console.error('Error fetching search results:', error);
      }
    });
};

window.clearSearch = function (inputId) {
  const input = document.getElementById(inputId);
  input.value = '';
  input.dispatchEvent(new Event('input'));
  input.focus();
};
